import React, {useEffect} from 'react';

import useCarousel from '@stencil/hook-use-carousel';
import {defaultTheme} from '@stencil/build-theme';
import HappyAngleLeftIcon from '@stencil/icons/src/HappyAngleLeftIcon/HappyAngleLeftIcon';
import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';
import HappyImgPlaceholder from '@stencil/icons/src/HappyImgPlaceholder/HappyImgPlaceholder';

// Types
import {PrivateSpace, SharedSpaces} from '@stencil/hotels-cg-reducer/src/details/types';

//Styles
import * as S from '../HomeStaySpaces.styles';

interface HomeStaySpacesItemListProps {
  spaceList: PrivateSpace[] | SharedSpaces[];
  isPrivateSpace?: boolean;
  sharedSpacesLength?: number;
  handlerOnClickRoomCard: (item: any, isPrivateSpace: boolean) => void;
}

const HomeStaySpacesItemList: React.FC<HomeStaySpacesItemListProps> = ({
  spaceList = [],
  isPrivateSpace,
  sharedSpacesLength = 0,
  handlerOnClickRoomCard = item => {},
}) => {
  const {
    emblaRef,
    emblaApi,
    scrollPrevious,
    scrollNext,
    onSelect,
    leftArrowIsActive,
    rightArrowIsActive,
  } = useCarousel({
    emblaOptions: {
      align: 'start',
      containScroll: 'trimSnaps',
    },
  });

  useEffect(() => {
    emblaApi?.reInit();
    emblaApi?.scrollTo(0);
    if (onSelect) onSelect();
  }, [emblaApi, spaceList]);

  if (!spaceList?.length) return null;

  return (
    <>
      <S.HomeStaySpacesItemListWrapper>
        <S.SpacesItemListContainer
          ref={emblaRef}
          className={isPrivateSpace ? 'privateSpaceList' : 'publicSpaceList'}
          isSharedLeftBtnEnabled={!isPrivateSpace && leftArrowIsActive}
          isPrivateRightBtnEnabled={isPrivateSpace && rightArrowIsActive}
        >
          <S.SpacesItemList>
            {spaceList.map((item, idx) => {
              return (
                <S.HomeStaySpacesCardWrapper
                  onClick={handlerOnClickRoomCard.bind(this, item, Boolean(isPrivateSpace))}
                  key={`${item?.id}_${idx}_${item?.name}`}
                >
                  <S.HomeStaySpacesImgWrapper>
                    <S.HomeStaySpacesImg
                      src={item?.media?.[0]?.url || ''}
                      alt={item?.media?.[0]?.mediaType || 'image'}
                    />
                    <S.HomeStaySpacesImgCountWrapper>
                      <HappyImgPlaceholder className="countImg" />
                      <strong>1</strong>
                      <span>{`/${item?.media?.length || 1}`}</span>
                    </S.HomeStaySpacesImgCountWrapper>
                  </S.HomeStaySpacesImgWrapper>
                  <S.HomeStaySpacesCardContentWrapper>
                    <p className="bedroomTextWrapper">
                      <span className="bedroomText">{item?.name}</span>
                    </p>
                    <p className="featureText">
                      {item?.descriptionText
                        ? item?.descriptionText
                        : item?.spaceInclusions?.join(', ')}
                    </p>
                  </S.HomeStaySpacesCardContentWrapper>
                </S.HomeStaySpacesCardWrapper>
              );
            })}
          </S.SpacesItemList>
        </S.SpacesItemListContainer>
        {isPrivateSpace && Boolean(sharedSpacesLength) && <S.LineDivider />}
      </S.HomeStaySpacesItemListWrapper>
      {leftArrowIsActive && (
        <S.SliderArrowLeft
          data-testid="home-stay-spaces-left-slider-arrow"
          onClick={scrollPrevious}
          isPrivateSpace={Boolean(isPrivateSpace)}
        >
          <HappyAngleLeftIcon fill={defaultTheme.colors.goBrandBlue.base} />
        </S.SliderArrowLeft>
      )}
      {rightArrowIsActive && (
        <S.SliderArrowRight
          isPrivateSpace={Boolean(isPrivateSpace)}
          data-testid="home-stay-spaces-right-slider-arrow"
          onClick={scrollNext}
        >
          <HappyAngleRightIcon fill={defaultTheme.colors.goBrandBlue.base} />
        </S.SliderArrowRight>
      )}
    </>
  );
};

export default HomeStaySpacesItemList;
